import React from "react";

const SectionTitleFive = ({ title, text }) => {
  return (
    <div className="section__title--5">
      <h2>{title}</h2>
      <p>{text}</p>
    </div>
  );
};

export default SectionTitleFive;
